<template>
  <div class="screencasts">
    <filters
      v-model="form"
      :date-type="dateType"
      :enable-all-users="true"
      :force-all-users="isHighLevelUser"
      :user-search-col="3"
      :timezone-col="3"
      :date-range-col="3"
      :enable-tabs="true"
      :tabs="tabs"
      :selected-tab="activeTab"
      @timezone-changed="updateTimezone"
      @tab-select="activeTab = $event"
    >
      <template #title>
        {{ $t('Time Interval') }}
        <span v-if="activeTab === 3">
          ({{ FORMAT_DATE_RANGE(form.start_date, form.end_date) }})
        </span>
        <span v-else>
          ({{ FORMAT_DATE_RANGE(getStartEnd[activeTab].start, moment(getStartEnd[activeTab].end).subtract(1, 'day')) }})
        </span>
      </template>
    </filters>

    <div
      v-if="!getUserId"
      class="text-right mb-2"
    >
      <portal to="breadcrumb">
        <circular-countdown
          :duration="60"
          :size="40"
          :stroke-width="6"
          :restart-on-complete="true"
          tooltip-title="Refreshes Screenshots every 60 seconds"
          tooltip-placement="left"
          @complete="fetchScreencasts = true"
        />
      </portal>
    </div>

    <day-view
      class="pt-1"
      :date-range="getStartEnd[activeTab]"
      :user-id="getUserId"
      :type="tabs[activeTab].type"
      :time-zone="getTimeZone"
      :fetch-screencasts="fetchScreencasts"
      @update:fetchScreencasts="fetchScreencasts = $event"
    />
  </div>
</template>

<script>
import Filters from '@/views/common/components/Filter.vue'
import { mapActions, mapGetters } from 'vuex'
import { getUserData } from '@/auth/utils'
import moment from 'moment'
import DayView from './Day.vue'
import CircularCountdown from '../common/components/CircularCountdown.vue'

export default {
  components: {
    Filters,
    DayView,
    CircularCountdown,
  },
  data() {
    return {
      moment,
      form: {
        date: this.TODAY({ localTime: false }),
        time_zone: localStorage.timezone ?? 'Asia/Kathmandu',
        userId: this.$route.query.user_id ?? null,
        start_date: this.$route.query.start_date || this.TODAY({ localTime: false }),
        end_date: this.$route.query.end_date || this.TODAY({ localTime: false }),
      },
      tabs: [
        { label: 'Day', type: 'day' },
        { label: 'Week', type: 'week' },
        { label: 'Month', type: 'month' },
        { label: 'Date Range', type: 'month' },
      ],
      activeTab: this.$route.query.start_date ? 3 : 0,
      fetchScreencasts: false,
    }
  },
  computed: {
    ...mapGetters('project', ['GET_SELECTED_USER']),
    isHighLevelUser() {
      return ['Project Owner', 'Project Manager'].includes(localStorage.projectUserRole)
    },
    getUserId() {
      return this.form.userId
    },
    getTimeZone() {
      return this.form.time_zone
    },
    getStartEnd() {
      return [
        {
          start: `${this.form.date} 00:00:00`,
          end: this.ADD_DAYS(this.form.date, 1, 'YYYY-MM-DD 00:00:00').start,
        },
        {
          start: this.INTERVAL_IN_WEEKS(this.form.date).start,
          end: this.INTERVAL_IN_WEEKS(this.form.date).end,
        },
        {
          start: this.INTERVAL_IN_MONTH(this.form.date).start,
          end: this.INTERVAL_IN_MONTH(this.form.date).end,
        },
        {
          start: `${this.form.start_date} 00:00:00`,
          end: this.ADD_DAYS(this.form.end_date, 1, 'YYYY-MM-DD 00:00:00').start,
        },
      ]
    },
    dateType() {
      switch (this.activeTab) {
      case 1:
        return 'week'
      case 2:
        return 'month'
      case 3:
        return 'range'
      default:
        return 'single'
      }
    },
  },
  watch: {
    form: {
      handler(newValue) {
        this.storeFilterQuery('screenshots-filter', { ...newValue })
      },
      deep: true,
    },
    GET_SELECTED_USER: {
      handler(val) {
        if (val && val !== this.form.userId) this.form.userId = val
      },
      immediate: true,
    },
    getUserId(val) {
      if (val) this.setSelectedUser(val)
    },
  },
  mounted() {
    if (this.isHighLevelUser) this.form.userId = null
    else if (this.$route.query.start_date && this.$route.query.start_date && !this.$route.query.user_id) {
      this.form.userId = getUserData().uuid
    }
  },
  methods: {
    ...mapActions('project', ['setSelectedUser']),
    updateTimezone() {
      if (this.isAfterTODAY(this.form.date)) this.form.date = this.TODAY({ localTime: false })
      if (this.isAfterTODAY(this.form.start_date)) this.form.start_date = this.TODAY({ localTime: false })
      if (this.isAfterTODAY(this.form.end_date)) this.form.end_date = this.TODAY({ localTime: false })
    },
  },
}
</script>
